module.exports = __webpack_public_path__ + "static/articleimg3-aff9724e986bfd6ed8b9ea23fb2f993d.jpeg";